import * as React from 'react'
import * as RadixSelect from '@radix-ui/react-select'
import {Check} from '@mui/icons-material'
import {twMerge} from 'tailwind-merge'





export const SelectItem = React.forwardRef(
  ({className, children, endAdornment, ...props}, ref) => (
    React.createElement(RadixSelect.Item, {
      ref: ref,
      className: twMerge(
        'flex h-10 w-full cursor-pointer select-none items-center justify-between rounded text-sm outline-none hover:bg-slate-100 focus:bg-slate-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        className
      ),
      ...props,}

      , React.createElement('span', { className: "pl-2",}
        , React.createElement(RadixSelect.ItemText, null, children)
      )

      , React.createElement('div', { className: "flex items-center space-x-2 pr-2"   ,}
        , React.createElement(RadixSelect.ItemIndicator, { className: "pt-1",}
          , React.createElement(Check, { className: "h-5 w-5" ,} )
        )
        , endAdornment && endAdornment
      )
    )
  )
)
